// Название стенда в «Установке». Форма подставляет его сама: при выборе подключения — из прошлой
// установки на него, при проверке сервера с Midori — имя, которое стенд показывает сейчас (`GET
// /api/v1/stand`; менеджер без истории установок иначе предлагал пустое поле, и накат мог переименовать
// стенд — SSH4, 09.10). Подставленное меняется вместе с источником; набранное руками — остаётся.
// Оба правила отдают пару [значение поля, что форма подставила сама] — по второму следующая подстановка
// отличает своё от набранного.

const autofilled = (current, auto) => !current.trim() || current === (auto || '');

export const standNameOnTargetChange = (current, auto, nextTarget) => {
  if (!autofilled(current, auto)) return [current, auto];
  const name = nextTarget?.last_stand_name || '';
  return [name, name];
};

// Имя с сервера сильнее истории: это то, что стенд показывает сейчас. Сервер без имени поле не трогает.
export const standNameAfterPreflight = (current, auto, serverName) => {
  const name = (serverName || '').trim();
  if (!name || !autofilled(current, auto)) return [current, auto];
  return [name, name];
};
